import * as React from "react";

export const SvgLocation = ({ "data-testid": dataTestId = null, ...props }) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" data-testid={dataTestId} {...props}>
		<path
			d="M9.58 1C5.953 1 3 4.005 3 7.699c0 2.066 1.045 4.574 3.106 7.454a32.838 32.838 0 0 0 3.057 3.673.587.587 0 0 0 .826.01 29.658 29.658 0 0 0 3.064-3.582c2.063-2.837 3.108-5.379 3.108-7.555C16.161 4.005 13.21 1 9.581 1Zm.009 16.564c-1.326-1.438-5.412-6.171-5.412-9.865 0-3.045 2.424-5.522 5.404-5.522s5.403 2.477 5.403 5.522c0 3.893-4.064 8.47-5.395 9.865Z"
			fill={props.color ?? "#A8A8A8"}
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={0.4}
		/>
		<path
			d="M9.58 4.156a3.22 3.22 0 0 0-3.217 3.217 3.22 3.22 0 0 0 3.217 3.218 3.22 3.22 0 0 0 3.218-3.218A3.22 3.22 0 0 0 9.58 4.156Zm0 5.258a2.042 2.042 0 0 1-2.04-2.04c0-1.126.916-2.04 2.04-2.04 1.125 0 2.04.914 2.04 2.04 0 1.124-.915 2.04-2.04 2.04Z"
			fill={props.color ?? "#A8A8A8"}
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={0.4}
		/>
	</svg>
);
